<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <span>{{ 'SUAS.ACCOUNT.DETAILS.TITLE' | translate }}</span>
    <span class="ui-icon-close c-p" matDialogClose></span>
  </div>
  <div class="body">
    <div class="flex-col gap-8">
      <label>{{ 'SUAS.ACCOUNT.DETAILS.LANGUAGE' | translate }}</label>
      <mat-radio-group class="flex-col" [formControl]="userLangFormControl">
        <mat-radio-button [value]="language.ENGLISH">
          {{ langString[language.ENGLISH] }}
        </mat-radio-button>
        <mat-radio-button [value]="language.SPANISH">
          {{ langString[language.SPANISH] }}
        </mat-radio-button>
        <mat-radio-button [value]="language.HEBREW">
          {{ langString[language.HEBREW] }}
        </mat-radio-button>
        <mat-radio-button [value]="language.JAPANESE">
          {{ langString[language.JAPANESE] }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="footer flex-row end-center gap-8">
    <ui-button
      [text]="'SUAS.COMMON.CANCEL' | translate"
      type="default"
      (clickAction)="close()"
    ></ui-button>
    <ui-button
      [disabled]="userLangFormControl.invalid"
      [text]="'SUAS.COMMON.SAVE' | translate"
      (clickAction)="save()"
    ></ui-button>
  </div>
</div>
